import React, { useReducer, Fragment } from 'react';
import styled from 'styled-components';
import { Box, Button, Form, FormField, Heading, Text } from 'grommet';
import queryString from 'query-string';
import { compose } from 'recompose';
import GoogleSignInButton from './GoogleSignInButton';
import * as ROUTES from 'components/common/Routes';
import { withFirebaseConsumer } from 'components/common/Firebase';
import { addNotification } from 'AppEntry';

const NewHeading = styled(Heading)`
  color: #000;
  margin-bottom: 25px;
`;

const Container = styled(Box)`
  width: 400px;
`;

const AuthBase = props => {
  const values = queryString.parse(props.location.search);
  const { oobCode, mode } = values;

  const initialVisibilityFilter =
    props.initialVisibilityFilter || mode || 'sign in';

  const initialState = {
    visibilityFilter: initialVisibilityFilter,
    userMgmt: {
      email: null,
      oobCode: oobCode === undefined ? null : oobCode
    }
  };

  const reducer = (state, action) => {
    switch (action.type) {
      case 'sign-up': {
        return {
          ...state,
          ...action.payload
        };
      }
      case 'forgot password': {
        return {
          ...state,
          ...action.payload
        };
      }
      case 'resetPassword': {
        return {
          ...state
        };
      }
      case 'recoverEmail': {
        //recover email
      }
      case 'verifyEmail': {
        //verify email
      }
      case 'sign-in': {
        return {
          ...state,
          ...action.payload
        };
      }
      case 'password reset email confirmation': {
        return { ...state, visibilityFilter: action.payload.visibilityFilter };
      }
      default: {
        return state;
      }
    }
  };

  const [state, dispatch] = useReducer(reducer, initialState);

  const signInWithEmailAndPassword = async (email, password) => {
    try {
      await props.firebase.doSignInWithEmailAndPassword(email, password);
      props.history.push(ROUTES.LANDING);
    } catch (error) {
      console.log(error.message);
      addNotification('Error!', error.message, 'error');
    }
  };

  const signUp = async (email, password, passwordConfirmation) => {
    try {
      if (password !== passwordConfirmation)
        throw new Error('Your passwords do not match.');
      await props.firebase.doCreateUserWithEmailAndPassword(email, password);
      await props.firebase.doSendEmailVerification();
      addNotification(
        'Success!',
        'An email was sent to you requesting you verify your email address.',
        'success'
      );
      props.history.push(ROUTES.LANDING);
    } catch (error) {
      console.log(error.message);
      addNotification('Error!', error.message, 'error');
    }
  };

  const sendResetPasswordEmail = async email => {
    try {
      await props.firebase.doSendPasswordResetEmail(email);
      addNotification(
        'Success',
        'Please check your email for password reset link',
        'success'
      );
      dispatch({
        type: 'password reset email confirmation',
        payload: {
          visibilityFilter: 'sign in'
        }
      });
    } catch (error) {
      console.log(error.message);
      addNotification('Error!', error.message, 'error');
    }
  };

  const resetPassword = async (oobCode, password, passwordConfirmation) => {
    try {
      if (password !== passwordConfirmation)
        throw new Error('Your passwords do not match.');
      await props.firebase.doConfirmPasswordReset(oobCode, password);
      dispatch({ type: 'sign-in', payload: { visibilityFilter: 'sign in' } });
      addNotification(
        'Success!',
        'Your password was reset. Please sign in!',
        'success'
      );
    } catch (error) {
      console.log(error.message);
      addNotification('Error!', error.message, 'error');
    }
  };

  const { visibilityFilter } = state;

  return (
    <Fragment>
      <Box
        direction="row"
        height="large"
        margin={{ top: 'xlarge' }}
        pad="medium"
      >
        <Box basis="full" pad="small">
          <Container alignSelf="center" elevation="small" pad="small">
            <NewHeading alignSelf="center" color="brand" level="2">
              {visibilityFilter === 'resetPassword'
                ? 'reset password'
                : visibilityFilter}
            </NewHeading>
            <Form
              onSubmit={event => {
                event.preventDefault();
                const {
                  email,
                  password,
                  name,
                  passwordConfirmation
                } = event.value;
                switch (visibilityFilter) {
                  case 'sign in':
                    signInWithEmailAndPassword(email, password);
                    break;
                  case 'sign up':
                    signUp(email, password, passwordConfirmation);
                    break;
                  case 'resetPassword':
                    resetPassword(
                      state.userMgmt.oobCode,
                      password,
                      passwordConfirmation
                    );
                    break;
                  default:
                    return null;
                }
              }}
            >
              <Box align="center">
                {visibilityFilter === 'forgot password' ||
                visibilityFilter === 'resetPassword' ? null : (
                  <Fragment>
                    <GoogleSignInButton />
                    <Text weight="bold">or</Text>
                  </Fragment>
                )}
                {visibilityFilter === 'sign up' ? (
                  <FormField
                    /*error=""
                              help=""*/
                    name="name"
                    label="name"
                    required={true}
                    //validate={{ regexp: /^[a-z]/i }}
                  />
                ) : null}
                {visibilityFilter !== 'resetPassword' ? (
                  <FormField
                    /*error=""
                                help=""*/
                    id="email"
                    name="email"
                    label="email address"
                    required={true}
                    //validate={{ regexp: /^[a-z]/i }}
                  />
                ) : null}
                {visibilityFilter === 'sign up' ||
                visibilityFilter === 'sign in' ||
                visibilityFilter === 'resetPassword' ? (
                  <FormField
                    /*error=""
                                help=""*/
                    type="password"
                    name="password"
                    label="password"
                    required={true}
                    //validate={ (value, values) => { } }
                  />
                ) : null}
                {visibilityFilter === 'sign up' ||
                visibilityFilter === 'resetPassword' ? (
                  <FormField
                    /*error=""
                              help=""*/
                    type="password"
                    name="passwordConfirmation"
                    label="password confirmation"
                    required={true}
                    //validate={{ regexp: /^[a-z]/i }}
                  />
                ) : null}
                {visibilityFilter === 'forgot password' ? (
                  <Button
                    label={<Text>send password reset</Text>}
                    margin={{ bottom: 'small', top: 'small' }}
                    primary={true}
                    onClick={event => {
                      const email = event.currentTarget.parentNode.parentNode.querySelector(
                        'input'
                      ).value;
                      sendResetPasswordEmail(email); //doing this in the onClick as a workaround
                    }}
                  />
                ) : (
                  <Button
                    label={
                      <Text>
                        {visibilityFilter === 'resetPassword' && 'reset password'}
                        {visibilityFilter === 'sign up' && 'try for free'}
                        {visibilityFilter === 'sign in' && 'sign in'}
                      </Text>
                    }
                    margin={{ bottom: 'small', top: 'small' }}
                    primary={true}
                    type="submit"
                  />
                )}
                {visibilityFilter === 'sign in' ? (
                  <Button
                    onClick={() =>
                      dispatch({
                        type: 'sign-up',
                        payload: { visibilityFilter: 'sign up' }
                      })
                    }
                    label={<Text color="brand">try for free</Text>}
                    plain={true}
                  />
                ) : (
                  <Button
                    onClick={() =>
                      dispatch({
                        type: 'sign-in',
                        payload: { visibilityFilter: 'sign in' }
                      })
                    }
                    label={<Text color="brand">sign in</Text>}
                    plain={true}
                  />
                )}
                {visibilityFilter === 'forgot password' ? null : (
                  <Button
                    onClick={() =>
                      dispatch({
                        type: 'forgot password',
                        payload: { visibilityFilter: 'forgot password' }
                      })
                    }
                    label={<Text color="brand">forgot password</Text>}
                    plain={true}
                  />
                )}
              </Box>
            </Form>
          </Container>
        </Box>
      </Box>
    </Fragment>
  );
};

const SignInLink = () => (
  <p className="log-in">
    <span className="or-button">or</span>
    <a href={ROUTES.AUTH}>Sign in</a>
  </p>
);

export { SignInLink };

export const Auth = compose(withFirebaseConsumer)(AuthBase);
